import { createAction, props } from '@ngrx/store';

export const loadAddExistingUserAdminDirectors = createAction(
  '[AddExistingUserAdminDirector] Load AddExistingUserAdminDirectors',
  props<{
    groupForUserRoleIds: string[];
    businessId: string;
    userRoleId: string;
    invites: string[];
  }>()
);

export const loadAddExistingUserAdminDirectorsSuccess = createAction(
  '[AddExistingUserAdminDirector] Load AddExistingUserAdminDirectors Success',
  props<{ response: string }>()
);

export const loadAddExistingUserAdminDirectorsFailure = createAction(
  '[AddExistingUserAdminDirector] Load AddExistingUserAdminDirectors Failure',
  props<{ error: Error | any }>()
);
